import { JourneyVariant } from '@r6digital/rapidstor-types/react/entities/Journey';

export function getBackDestination(path: string): string {
    if (path.startsWith('/reservation-with-fee')) {
        if (window.rapidstor_settings.app_config.journey.variant === JourneyVariant.JBL) {
            return '/customise-booking';
        }
        return '/';
    }

    if (
        window.rapidstor_settings.app_config.journey.variant
    === JourneyVariant.STANDARD_UNIT_LISTING
    ) {
        return '/';
    }

    switch (path) {
        case '/':
            return '/';

        case 'unit-listing':
            return '/';

        case 'book-unit':
            if (window.rapidstor_settings.app_config.pages.storageType) {
                return '/unit-listing';
            }
            return '/';

        case '/customise-booking':
            return '/book-unit';

        case '/booking-confirmed':
            return '/';

        default:
            return '/';
    }
}
